import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import CrmDropdown from '../../shared/components/CrmDropdown';
import DateRangePicker from '../../ReportingDashboard/components/DateRangePicker';

const MobileFiltersSheet = ({
  venueFilter, setVenueFilter, venueOptions,
  dateRange, setDateRange,
  searchTerm, setSearchTerm,
  onClose, onClearAll, activeFilterCount,
}) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = prev;
      }
    };
  }, []);

  return (
    <div onClick={onClose} className="tickets-filters-sheet-backdrop">
      <div onClick={(e) => e.stopPropagation()} className="tickets-filters-sheet">
        <div className="tickets-filters-sheet-header">
          <span className="tickets-filters-sheet-title">Filters</span>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="tickets-filters-sheet-close"
          >
            <i className="fal fa-times" style={{ fontSize: 18 }} />
          </button>
        </div>

        <div className="tickets-filters-sheet-body">
          <div>
            <label className="tickets-filters-sheet-field-label">Venue</label>
            <CrmDropdown
              value={venueFilter}
              options={venueOptions}
              onChange={setVenueFilter}
              placeholder="All venues"
              minWidth="100%"
              ariaLabel="Filter by venue"
            />
          </div>

          <div>
            <label className="tickets-filters-sheet-field-label">Date range</label>
            <DateRangePicker dateRange={dateRange} onChange={setDateRange} align="left" />
          </div>

          <div>
            <label className="tickets-filters-sheet-field-label">Search</label>
            <div className="tickets-search-input-wrap">
              <i className="fal fa-search tickets-search-input-icon" />
              <input
                type="text"
                placeholder="Search events or artists"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="tickets-search-input tickets-search-input--mobile"
              />
            </div>
          </div>
        </div>

        <div className="tickets-filters-sheet-footer">
          <button
            type="button"
            onClick={onClearAll}
            disabled={activeFilterCount === 0}
            className="btn btn-setlist-link-gray"
          >
            Clear all
          </button>
          <button
            type="button"
            onClick={onClose}
            className="btn btn-setlist-primary"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

MobileFiltersSheet.propTypes = {
  venueFilter: PropTypes.string,
  setVenueFilter: PropTypes.func.isRequired,
  venueOptions: PropTypes.array.isRequired,
  dateRange: PropTypes.object.isRequired,
  setDateRange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  activeFilterCount: PropTypes.number.isRequired,
};

export default MobileFiltersSheet;
